import React from "react";
import { observer } from "mobx-react";
import type { WalletStore } from "../../stores/wallet/wallet-store";
import { FONT_COLOR, FONT_VARIANT } from "../../../../components/fonts/font-props";
import ThresholdTrigger from "./threshold-trigger";
import "./wallet-status-bar.scss";
import Currency from "../../../../components/currency/currency";
import { isSet } from "../../../../models/model-types-methods";
import FontBody2 from "../../../../components/fonts/font-body2/font-body2";

interface Props {
    walletStore: WalletStore;
}

const WalletStatusBar: React.FC<Props> = observer(({walletStore} :Props) => {
    if (!isSet(walletStore.walletStatusBarMaximumPoint) || !isSet(walletStore.lastRechargeWalletAfterAmount)) {
        return null;
    }

    const balancePercentage = walletStore.amount / walletStore.walletStatusBarMaximumPoint! * 100;
    const balanceLineWidth = Math.min(balancePercentage, 100);
  
    const isBelowThreshold = walletStore.isAutoRechargeEnabled && walletStore.amount < (walletStore.rechargeThreshold ?? 0);
    const balanceLineClass = `wallet-status-bar-amount-line ${isBelowThreshold ? "wallet-status-bar-amount-line-negative" : "wallet-status-bar-amount-line-positive"}`;
    
    return (
        <div className="wallet-status-bar">
          <div className="wallet-status-bar-labels">
            <FontBody2 color={FONT_COLOR.NEUTRAL3} variant={FONT_VARIANT.BOLD}>
                <Currency amount={0} currencyCode={walletStore.walletCurrencyCode!} />
            </FontBody2>
            <FontBody2 color={FONT_COLOR.NEUTRAL3}>
                {"Balance after last recharge: "}
                <FontBody2 color={FONT_COLOR.NEUTRAL3} variant={FONT_VARIANT.BOLD}>
                    {isSet(walletStore.lastRechargeWalletAfterAmount) && <Currency amount={walletStore.lastRechargeWalletAfterAmount!} currencyCode={walletStore.walletCurrencyCode!} />}
                </FontBody2>
            </FontBody2>
          </div>
    
          <div className="wallet-status-bar-line">
            <div className={balanceLineClass} style={{ width: `${balanceLineWidth}%` }} />
            {walletStore.isAutoRechargeEnabled && <ThresholdTrigger walletStore={walletStore} />}
          </div>
        </div>
      );
});

export default WalletStatusBar;